import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    ButtonVisualizarEvolucaoReservaFinanceira,
    ButtonVisualizarDiagnosticoAposentadoriaIndependenciaFinanceira,
    ButtonVisualizarComparacaoCenarios,
    ButtonVisualizarComparacaoEstudos,
} from '../../../business-components/Button/Button'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import DiagnosticoAposentadoriaIndependenciaFinanceiraPrimeiraReuniaoChart
    from '../estudo-chart/DiagnosticoAposentadoriaIndependenciaFinanceiraPrimeiraReuniaoChart'

import SimulacaoFinanceiraFormEvolucaoReservaFinanceira from './SimulacaoFinanceiraFormEvolucaoReservaFinanceira'

import ComparacaoCenariosEstudosChart from '../estudo-chart/ComparacaoCenariosEstudosChart'

import EstudoFormComparacaoCenariosEstudos from '../estudo-form/EstudoFormComparacaoCenariosEstudos'



export const CustomizedDialogsPopupDiagnosticoAposentadoriaIndependenciaFinanceira = ( {values, handleSubmitAutomatico,
    setFieldValue, estudo/*, onClose*/, maxWidth, fullScreen, close} ) => {

    return (
        <CustomizedDialogsPopup
            maxWidth={maxWidth ? maxWidth : 'lg'}
            fullScreen={fullScreen}
            popupTitle={LABEL.diagnosticoAposentadoriaIndependenciaFinanceira}
            PopupButton={ButtonVisualizarDiagnosticoAposentadoriaIndependenciaFinanceira}
            popupComponent={
                <DiagnosticoAposentadoriaIndependenciaFinanceiraPrimeiraReuniaoChart
                    values={values}
                    setFieldValue={setFieldValue}
                    estudo={estudo}
                    report={true}
                    popup={true}
                />
            }
            //onClose={onClose}
            onOpen={
                () => {
                    handleSubmitAutomatico(values)
                }
            }
            //onClose={
            //    () => {
            //        //onClose()
            //        handleSubmitAutomatico(values)
            //    }
            //}
            close={close}
        />
    )
}

export const CustomizedDialogsPopupEvolucaoReservaFinanceira = ( {values, handleSubmitAutomatico, estudo} ) => {

    return (
        <CustomizedDialogsPopup
            maxWidth='lg'
            popupTitle={LABEL.evolucaoReservaFinanceira}
            PopupButton={ButtonVisualizarEvolucaoReservaFinanceira}
            popupComponent={
                <SimulacaoFinanceiraFormEvolucaoReservaFinanceira
                    values={values}
                    estudo={estudo}
                    popup={true}
                />
            }
            onClose={
                () => {
                    handleSubmitAutomatico(values)
                }
            }
        />
    )
}

export const CustomizedDialogsPopupComparacaoCenarios = ( {variaveisGlobais, values, handleSubmitAutomatico, estudo, linhaTipoLicenca,
    jsonConfiguracao, jsonPagina, jsonUsuario, jsonUsuarioAdmin} ) => {

    return (
        <CustomizedDialogsPopup
            maxWidth='lg'
            popupTitle={LABEL.comparacaoCenarios}
            PopupButton={ButtonVisualizarComparacaoCenarios}
            popupComponent={
                <>
                    <ComparacaoCenariosEstudosChart
                        variaveisGlobais={variaveisGlobais}
                        values={values}
                        handleSubmitAutomatico={handleSubmitAutomatico}
                        estudo={estudo}
                        report={true}
                        linhaTipoLicenca={linhaTipoLicenca}
                        jsonConfiguracao={jsonConfiguracao}
                        jsonPagina={jsonPagina}
                        jsonUsuario={jsonUsuario}
                        jsonUsuarioAdmin={jsonUsuarioAdmin}
                        comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoCenario}
                        simulacaoFinanceira={true}
                        popup={true}
                    />

                    <EstudoFormComparacaoCenariosEstudos
                        variaveisGlobais={variaveisGlobais}
                        values={values}
                        handleSubmitAutomatico={handleSubmitAutomatico}
                        estudo={estudo}
                        linhaTipoLicenca={linhaTipoLicenca}
                        jsonConfiguracao={jsonConfiguracao}
                        jsonPagina={jsonPagina}
                        jsonUsuario={jsonUsuario}
                        jsonUsuarioAdmin={jsonUsuarioAdmin}
                        comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoCenario}
                        simulacaoFinanceira={true}
                    />
                </>
            }
            onClose={
                () => {
                    handleSubmitAutomatico(values)
                }
            }
        />
    )
}

export const CustomizedDialogsPopupComparacaoEstudos = ( {variaveisGlobais, values, handleSubmitAutomatico, estudo, linhaTipoLicenca,
    jsonConfiguracao, jsonPagina, jsonUsuario, jsonUsuarioAdmin} ) => {

    return (
        <CustomizedDialogsPopup
            maxWidth='lg'
            popupTitle={LABEL.comparacaoEstudos}
            PopupButton={ButtonVisualizarComparacaoEstudos}
            popupComponent={
                <>
                    <ComparacaoCenariosEstudosChart
                        variaveisGlobais={variaveisGlobais}
                        values={values}
                        handleSubmitAutomatico={handleSubmitAutomatico}
                        estudo={estudo}
                        report={true}
                        linhaTipoLicenca={linhaTipoLicenca}
                        jsonConfiguracao={jsonConfiguracao}
                        jsonPagina={jsonPagina}
                        jsonUsuario={jsonUsuario}
                        jsonUsuarioAdmin={jsonUsuarioAdmin}
                        comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoEstudo}
                        simulacaoFinanceira={true}
                        popup={true}
                    />

                    <EstudoFormComparacaoCenariosEstudos
                        variaveisGlobais={variaveisGlobais}
                        values={values}
                        handleSubmitAutomatico={handleSubmitAutomatico}
                        estudo={estudo}
                        linhaTipoLicenca={linhaTipoLicenca}
                        jsonConfiguracao={jsonConfiguracao}
                        jsonPagina={jsonPagina}
                        jsonUsuario={jsonUsuario}
                        jsonUsuarioAdmin={jsonUsuarioAdmin}
                        comparacaoCenariosEstudosTipo={HARDCODE.comparacaoCenariosEstudosTipoEstudo}
                        simulacaoFinanceira={true}
                    />
                </>
            }
            onClose={
                () => {
                    handleSubmitAutomatico(values)
                }
            }
        />
    )
}